/**
 * Blog Table of Contents
 * Auto-generates a TOC from h2/h3 headings in the article content.
 * Highlights the active section on scroll.
 */
class BlogTableOfContents extends HTMLElement {
  connectedCallback() {
    this.content = document.querySelector('.blog-post-content');
    if (!this.content) return;

    this.headings = this.content.querySelectorAll('h2, h3');
    if (this.headings.length < 2) {
      this.style.display = 'none';
      return;
    }

    this.buildTOC();
    this.observeHeadings();
    this.setupToggle();
  }

  buildTOC() {
    const list = this.querySelector('.blog-toc__list');
    if (!list) return;

    this.headings.forEach((heading, index) => {
      const id = heading.id || `section-${index}`;
      heading.id = id;

      const li = document.createElement('li');
      li.className = `blog-toc__item blog-toc__item--${heading.tagName.toLowerCase()}`;

      const a = document.createElement('a');
      a.href = `#${id}`;
      a.className = 'blog-toc__link';
      a.textContent = heading.textContent;
      a.addEventListener('click', (e) => {
        e.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', `#${id}`);
      });

      li.appendChild(a);
      list.appendChild(li);
    });
  }

  observeHeadings() {
    this.links = this.querySelectorAll('.blog-toc__link');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setActive(entry.target.id);
          }
        });
      },
      { rootMargin: '-80px 0px -70% 0px', threshold: 0 }
    );

    this.headings.forEach((heading) => observer.observe(heading));
  }

  setActive(id) {
    this.links.forEach((link) => {
      link.classList.toggle('active', link.getAttribute('href') === `#${id}`);
    });
  }

  setupToggle() {
    const toggle = this.querySelector('.blog-toc__toggle');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      this.classList.toggle('blog-toc--collapsed');
    });
  }
}

customElements.define('blog-toc', BlogTableOfContents);
